import React from "react";

function SubHeader({ title, description, children }) {
  return (
    <div className="app-toolbar py-3 py-lg-6">
      <div className="app-container container-xxl d-flex justify-content-between flex-md-row flex-column">
        <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
          <h1 className="page-heading d-flex text-gray-900 fw-bold fs-3 flex-column justify-content-center my-0">
            {title && title}
          </h1>
          <span className="text-muted fw-semibold fs-7 my-0 pt-1">
            {description && description}
          </span>
        </div>
        {children}
      </div>
    </div>
  );
}

export default SubHeader;
